interface BookingToolPanelProps {
  [key: string]: any;
}

export default function BookingToolPanel(props: BookingToolPanelProps) {
    return (
        <>
        <div className="l-node-frontpage__block-small service">
            <div className="block-inner">
                <div className="block-header">
                    <h2>{props['booking-tool-header']}</h2>
                    <p>{props['booking-tool-text']}</p>
                  </div>
                  <div className="block-form">
                      booking form
                  </div>
            </div>
        </div>
        </>
    );
}